var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Suspense, lazy, useMemo } from 'react';
import { theme } from '../../features/entities/general';
const PrimaryLogo = lazy(() => import('./PrimaryLogo'));
const SecondaryLogo = lazy(() => import('./SecondaryLogo'));
const TertiaryLogo = lazy(() => import('./TertiaryLogo'));
const LogoComponent = (_a) => {
    var { type } = _a, logoProps = __rest(_a, ["type"]);
    switch (type) {
        case 'secondary':
            return _jsx(SecondaryLogo, Object.assign({}, logoProps));
        case 'tertiary':
            return _jsx(TertiaryLogo, Object.assign({}, logoProps));
        case 'primary':
        default:
            return _jsx(PrimaryLogo, Object.assign({}, logoProps));
    }
};
const HdLogo = (props) => {
    const { backgroundType, color } = props;
    const primaryColor = useMemo(() => (backgroundType === 'dark' ? theme.white_1 : theme.grey_1), [backgroundType]);
    const secondaryColor = useMemo(() => color === 'b/w'
        ? backgroundType === 'dark'
            ? theme.white_1
            : theme.grey_1
        : backgroundType === 'dark'
            ? theme.purple_3
            : theme.purple_2, [color, backgroundType]);
    return (_jsx(Suspense, { fallback: null, children: _jsx(LogoComponent, Object.assign({}, props, { primaryColor: primaryColor, secondaryColor: secondaryColor })) }));
};
export default HdLogo;
